var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBelkeit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 23 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-\xFCbelkeit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-\\xFCbelkeit",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.0000317,
    y1: 17.9999667,
    x2: 10.0000317,
    y2: 18.9999667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0000317,
    y1: 18.9999667,
    x2: 13.0000317,
    y2: 19.9999667,
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00003171,4.49996669 C6.31249991,5.46867959 5.18752111,6.031169 4.00003171,5.99996669",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0000317,4.49996669 C16.6875635,5.46867959 17.8125423,6.031169 19.0000317,5.99996669",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "6.00003171 9.99996669 9.00003171 9.99996669 6.50003171 7.49996669"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "17.0000317 9.99996669 14.0000317 9.99996669 16.5000317 7.49996669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5000317,17.9999667 C16.8807436,17.9999667 18.0000317,16.8806786 18.0000317,15.4999667 C18.0000317,14.1192548 16.8807436,12.9999667 15.5000317,12.9999667 L7.50003171,12.9999667 C6.11931983,12.9999667 5.00003171,14.1192548 5.00003171,15.4999667 C5.00003171,16.8806786 6.11931983,17.9999667 7.50003171,17.9999667",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5000317,19.9999667 C16.3954622,19.9999667 15.5000317,19.1045362 15.5000317,17.9999667 C15.5000317,16.8953972 14.6046012,15.9999667 13.5000317,15.9999667 L9.50003171,15.9999667 C8.39546221,15.9999667 7.50003171,16.8953972 7.50003171,17.9999667 C7.50003171,19.1045362 6.60460121,19.9999667 5.50003171,19.9999667 C4.67160458,19.9999667 4.00003171,20.6715396 4.00003171,21.4999667 C4.00003171,22.3283938 4.67160458,22.9999667 5.50003171,22.9999667 C6.37517822,23.0192017 7.23916451,22.800786 8.00003171,22.3679667 C8.56435617,22.0365868 9.27157718,22.0719479 9.80003171,22.4579667 C10.8144522,23.1807525 12.1756112,23.1807525 13.1900317,22.4579667 C13.7184862,22.0719479 14.4257072,22.0365868 14.9900317,22.3679667 C15.7538277,22.8025452 16.6215105,23.0210216 17.5000317,22.9999667 C18.3284588,22.9999667 19.0000317,22.3283938 19.0000317,21.4999667 C19.0000317,20.6715396 18.3284588,19.9999667 17.5000317,19.9999667 L17.5000317,19.9999667 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0000317,19.2459667 C24.1847745,14.653859 23.9656159,7.56824021 19.5050756,3.24353152 C15.0445353,-1.08117717 7.95552808,-1.08117717 3.49498778,3.24353152 C-0.965552514,7.56824021 -1.18471104,14.653859 3.00003171,19.2459667",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBelkeit);
export default __webpack_public_path__ + "static/media/icons-übelkeit.c6c76d30cee35d499d448a6cb2b15e0b.svg";
export { ForwardRef as ReactComponent };